<template>
    <v-menu
        class="collections-sort-input"
    >
        <template #activator="{ props }">
            <v-btn
                v-if="!compact"
                color="secondary"
                v-bind="props"
                variant="text"
            >
                Sort By
                <span v-if="modelValue">
                    :
                    <span class="text-medium-emphasis">{{ sortSelectedText }}</span>
                </span>
                <v-icon class="pl-2" size="28" :icon="mdiChevronDown"></v-icon>
            </v-btn>
            <v-btn
                v-else
                color="secondary"
                v-bind="props"
                icon
            >
                <v-icon :icon="mdiSort"></v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-item-group
                :modelValue="modelValue"
                @update:model-value="onSortChange"
            >
                <v-item
                    v-for="(item, index) in itemsSort"
                    :key="index"
                    :value="item.value"
                    #default="{ isSelected, toggle, value }"
                >
                    <v-list-item
                        @click="toggle"
                        :value="value"
                        :active="!!isSelected"
                    >
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                    </v-list-item>
                </v-item>
            </v-item-group>
        </v-list>
    </v-menu>
</template>

<script lang="ts" setup>
    import { mdiChevronDown, mdiSort } from '@mdi/js';
    import type {
        SelectListItem
    } from '~/types';

    const props = withDefaults(
        defineProps<{
            modelValue: Nilish<string>;
            compact: boolean;
        }>(),
        {
            compact: false
        }
    );

    const emit = defineEmits<{
        'update:modelValue': [value: string];
        'on-change': [value: void];
    }>();


    const itemsSort: SelectListItem<string>[] = [
        {
            text: 'Featured',
            value: 'sort_order'
        },
        {
            text: 'Newest',
            value: '-launch_date'
        },
        {
            text: 'Price: High-Low',
            value: '-min_price'
        },
        {
            text: 'Price: Low-High',
            value: 'min_price'
        }
    ];

    const sortSelectedText = computed<string>(
        () => itemsSort.find((o: SelectListItem<string>) => o.value === props.modelValue)?.text || ''
    );

    function onSortChange(order: Nilish<string>): void {
        emit('update:modelValue', order ?? '');
        setTimeout(() => emit('on-change'), 200);
    }
</script>

<style lang="scss"></style>
